module.exports = __webpack_public_path__ + "42afc84505c0901908faeb9aa442afb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/upper_west_side_4.jpg
// module id = 285
// module chunks = 0